export default "__VITE_ASSET__kPPKjhyq__"